var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"progress_wrap",attrs:{"data-order":_vm.progress_order}},[_c('span',{class:_vm.time_image_change()})])])}
var staticRenderFns = []

export { render, staticRenderFns }